import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';

const SaveView = props => {
    const {items} = props
    return (
        <InfiniteScroll
            dataLength={items.length} //This is important field to render the next data
            initialLoad={false}
            height='800px'
            endMessage={
                <p style={{textAlign: 'center'}}>
                    <b>Yay! You have seen it all</b>
                </p>
            }
            scrollableTarget="gigscroll"
        >
            {items}
        </InfiniteScroll>
    );
}

export default SaveView
